export default __webpack_public_path__ + "static/media/member_card_v3_mitra.1c1e35aa.png";